import { setEnvironmentValue } from './get-environment-value';
export class EnvironmentController {
    constructor(env) {
        this.env = env;
        for (const key in env) {
            setEnvironmentValue(key, env[key]);
        }
    }
    get(key) {
        return this.env[key];
    }
}
//# sourceMappingURL=environment.controller.js.map